<template>
    <div class="container">
        <app-header></app-header>
        
        <transition ><!-- name="slide" mode="out-in" -->
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
    import Header from './components/Header.vue';
    export default {
        components: {
            appHeader: Header
        },
        created() {
            this.$i18n.set(navigator.language);
        },
        mounted(){
            console.clear();
        }
    }
</script>
<style>
@import 'https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css';
@import 'https://cdn.firebase.com/libs/firebaseui/3.5.1/firebaseui.css';
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';
</style>




